import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JhiAlertService } from 'ng-jhipster';

import { IClauseExtensionMySuffix } from 'src/app/shared/model/clause-extension-my-suffix.model';
import { ClauseExtensionMySuffixService } from './clause-extension-my-suffix.service';
import { IFileDataMySuffix } from 'src/app/shared/model/file-data-my-suffix.model';
import { FileDataMySuffixService } from 'src/app/entities/file-data-my-suffix';
import { IScopeMySuffix } from 'src/app/shared/model/scope-my-suffix.model';
import { ScopeMySuffixService } from 'src/app/entities/scope-my-suffix';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { IMyOptions, IMyDateModel } from 'mydatepicker';
import { Principal } from 'src/app/core/auth/principal.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ConfirmationModalComponent } from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import { ConfirmationModelService } from 'src/app/shared/confirmation-modal/confirmation-model.service';
import { FutureDataType } from 'src/app/shared/model/future_data_type.model';
import { CommonUtils } from 'src/app/shared/util/common-utils';

@Component({
    selector: 'jhi-clause-extension-my-suffix-update',
    templateUrl: './clause-extension-my-suffix-update.component.html'
})
export class ClauseExtensionMySuffixUpdateComponent implements OnInit {

    @ViewChild('clauseExtensionChange') clauseExtensionChangeModal: ModalDirective;
    private _clauseExtension: IClauseExtensionMySuffix;
    isSaving: boolean;

    files: IFileDataMySuffix[];

    scopes: IScopeMySuffix[];

    fileMultiPartData: any;
    flag = false;

    isAnyFileSelected: boolean = false;
    
    maxChars = 1500;
    maxNameChar = 255;
  
    pdfOnly = 'application/pdf';
    isValidFile: boolean;
    // From effective date
    date: Date = new Date();
    resetDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate() - 1) }
    effectivepDatePickerOptions: IMyOptions = {
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.resetDateModel
    };
    fromEffeciveDate: any;
    dateModel = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate()
    }

    clauseExtensionCopy: any;

    constructor(
        private jhiAlertService: JhiAlertService,
        private clauseExtensionService: ClauseExtensionMySuffixService,
        private fileDataService: FileDataMySuffixService,
        private scopeService: ScopeMySuffixService,
        private activatedRoute: ActivatedRoute,
        private principal: Principal,
        private modalService: BsModalService,
        private confirmationModelService: ConfirmationModelService,
        private languageChangeService:LanguageChangeService,
    ) { 
                this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
    }

    ngOnInit() {
        this.effectivepDatePickerOptions.disableUntil = this.principal.dateFormateServerToClientMin(this.date);
        
        this.isValidFile = true;
        this.isSaving = false;
        this.activatedRoute.data.subscribe(({ clauseExtension }) => {
            this.clauseExtension = clauseExtension;
            this.clauseExtensionCopy = { ...this.clauseExtension };
            console.log('##### ::: ', this.clauseExtension.fileDTO.name);
        });
        this.fileDataService.query({ filter: 'clauseextension-is-null' }).subscribe(
            (res: HttpResponse<IFileDataMySuffix[]>) => {
                if (!this.clauseExtension.fileId) {
                    this.files = res.body;
                    console.log('@@@@@@@ ::: ', this.files);
                } else {
                    this.fileDataService.findByStrind(this.clauseExtension.fileId).subscribe(
                        (subRes: HttpResponse<IFileDataMySuffix>) => {
                            this.files = [subRes.body].concat(res.body);
                        },
                        (subRes: HttpErrorResponse) => this.onError(subRes.message)
                    );
                }
            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );

        // this.scopeService.query().subscribe(
        //     (res: HttpResponse<IScopeMySuffix[]>) => {
        //         this.scopes = res.body;
        //     },
        //     (res: HttpErrorResponse) => this.onError(res.message)
        // );
        this.fromEffeciveDate = { date: this.dateModel };
    }

    previousState() {
        window.history.back();
    }

    save() {
        // if (this.clauseExtension.clauseDescrition != null && this.clauseExtension.clauseDescrition != undefined) {
        if (CommonUtils.isNotNil(this.clauseExtension.clauseDescrition)) {
            if (this.clauseExtension.clauseDescrition.length > 500) {
                this.jhiAlertService.error('Clause description must be less than 500 characters');
                return;
            }
        }
        // if (this.clauseExtension.extensionDescription != null && this.clauseExtension.extensionDescription != undefined) {
        if (CommonUtils.isNotNil(this.clauseExtension.extensionDescription)) {
            if (this.clauseExtension.extensionDescription.length > 1500) {
                this.jhiAlertService.error('Extension description must be less than 1500 characters');
                return;
            }
        }
        // if (this.clauseExtension.name != null && this.clauseExtension.name != undefined) {         
        if (CommonUtils.isNotNil(this.clauseExtension.name)) {         
            if (this.clauseExtension.name.length > 255) {
                this.jhiAlertService.error('Name must be less than 255 characters');
                return;
            }
        }
        // monogoDB file upload call for the fileId

        // flag is to check is file uploaded or not

        if (!this.isValidFile) {
            return;
        }

        // if (this.flag) {
        //     this.uploadFile(this.fileMultiPartData);
        // } else {
        //     this.saveClauseExtension();
        // }

        this.saveClauseExtension();
    }

    proceedToSave() {
        this.subscribeToSaveResponse(this.clauseExtensionService.update(this.clauseExtension));
    }

    saveClauseExtension() {
        if (!this.isValidFile) {
            return;
        } else {
        }

        // From Effective Date
        let incDate = this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.clauseExtension.fromEffectiveDate = incDate;
        this.openConfirmationModalForFutureRecordDeletion();
    }

    saveOrUpdate() {

        if(this.flag){
            this.uploadFile(this.fileMultiPartData);
        }else{
            this.isSaving = true;
            // if (this.clauseExtension.id !== undefined) {
            if (CommonUtils.isNotNil(this.clauseExtension.id)) {
    
                if (this.clauseExtension.clauseExtensionType !== this.clauseExtensionCopy.clauseExtensionType) {
                    this.clauseExtensionChangeModal.show();
                } else {
                    this.subscribeToSaveResponse(this.clauseExtensionService.update(this.clauseExtension));
                }
    
            } else {
                this.subscribeToSaveResponse(this.clauseExtensionService.create(this.clauseExtension));
            }
        }
        
    }

    
    private subscribeToSaveResponse(result: Observable<HttpResponse<IClauseExtensionMySuffix>>) {
        result.subscribe(
            (res: HttpResponse<IClauseExtensionMySuffix>) => {
                this.onSaveSuccess(res)
            },
            (res: HttpErrorResponse) => this.onSaveError()
        );
    }

    private onSaveSuccess(res) {
        this.isSaving = false;
        this.deleteExistedFutureRecordDetails();
        this.previousState();
    }

    hideModal() {
        this.clauseExtension = null;
        this.clauseExtension = { ...this.clauseExtensionCopy };
        this.fromEffeciveDate = { date: this.dateModel };
        this.clauseExtensionChangeModal.hide();
    }

    hideSignatureModal() {
        this.flag = true;
        this.previousState();
        this.clauseExtensionChangeModal.hide();
    }

    private onSaveError() {
        this.isSaving = false;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    trackFileDataById(index: number, item: IFileDataMySuffix) {
        return item.id;
    }

    trackScopeById(index: number, item: IScopeMySuffix) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>, option: any) {
        if (selectedVals) {
            // for (let i = 0; i < selectedVals.length; i++) {
            //     if (option.id === selectedVals[i].id) {
            //         return selectedVals[i];
            //     }
            // }
            for (let _val of selectedVals) {
                if (option.id === _val) {
                    return _val;
                }
            }
        }
        return option;
    }
    get clauseExtension() {
        return this._clauseExtension;
    }

    set clauseExtension(clauseExtension: IClauseExtensionMySuffix) {
        this._clauseExtension = clauseExtension;
    }

    // init call
    uploadFileInitialMethod($event) {
        this.fileMultiPartData = $event.target.files[0];
        this.flag = true;

        this.fileMultiPartData = $event.target.files[0];
        let exten: string = this.fileMultiPartData.type;
        this.flag = true;

        if (exten.includes('application/pdf')) {
            this.isValidFile = true;
        } else {
            this.isValidFile = false;
            return;
        }
    }
    removefile() {
        this.flag = false;
        this.fileMultiPartData = '';
        this.clauseExtension.fileDTO.fileId = '';
        this.clauseExtension.fileDTO.name = '';
        this.clauseExtension.fileDTO.contenttype = '';
        this.clauseExtension.fileDTO.sizeInBytes = null;
    }
    // file upload method
    uploadFile(data) {
        let formData = new FormData();
        formData.append('file', data);
        this.clauseExtensionService.uploadFileService(formData).subscribe(response => {
            if (response.body.fileId) {
                console.log(response);
                this.clauseExtension.fileDTO.fileId = response.body.fileId;
                this.clauseExtension.fileDTO.name = response.body.name;
                this.clauseExtension.fileDTO.contenttype = response.body.contentType;
                this.clauseExtension.fileDTO.sizeInBytes = response.body.size;
                this.flag=false;
                // after getting the fileId from mongoDB invoking the saveClauseExtension
                this.saveOrUpdate();
            }
        });
    }

    trimName(event) {
        if (this.clauseExtension.name) {
            this.clauseExtension.name = this.clauseExtension.name.trim();
        }
    }

    trimClauseDescription($event) {
        // if (this.clauseExtension.clauseDescrition) {
            this.clauseExtension.clauseDescrition = this.clauseExtension.clauseDescrition.trim();
        // }
    }

    trimExtensionDescription($event) {
        // if (this.clauseExtension.extensionDescription) {
            this.clauseExtension.extensionDescription = this.clauseExtension.extensionDescription.trim();
        // }
    }
    onDateChanged(event: IMyDateModel) {
        let selectedFromEffectiveDate = this.principal.dateFormateClientToServer(event.date)
        console.log('onDateChanged(): ', selectedFromEffectiveDate);
        // if (this.clauseExtension.id !== null && this.clauseExtension.id !== undefined) {
        if (CommonUtils.isNotNil(this.clauseExtension.id)) {
            this.clauseExtensionService.findByIdAndFromEffectiveDate(this.clauseExtension.id, selectedFromEffectiveDate).subscribe(response => {
                console.log(response);
                if (CommonUtils.isNotNil(response.body) && response.body['isSuccess']) {
                    this.clauseExtension = response.body['payLoad'];
                }
            });
        }
    }


    // global modal open and close event
    bsModalRef: BsModalRef;

    isConfirmDeletion = false;
    /* this is how we open a Modal Component from another component */
    openConfirmationModalForFutureRecordDeletion() {
        this.isConfirmDeletion = false;
        // if (this.clauseExtension.id !== null && this.clauseExtension.id !== undefined) {
        if (CommonUtils.isNotNil(this.clauseExtension.id)) {
            let form_data = {
                masterId: this.clauseExtension.id,
                futureDataType: FutureDataType.CLAUSE_EXTENSION.valueOf(),
                fromEffectiveDateFormatted: this.clauseExtension.fromEffectiveDate
            }
            this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
                const resBody = response.body;
                if (resBody.isSuccess) {
                    const initialState = {
                        title: 'Clause Extension (' + this.clauseExtension.name + ')',
                        message: resBody.message,
                    };
                    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, { initialState, class: "modal-lg" });
                    this.bsModalRef.content.onClose.subscribe(result => {
                        if (result) {
                            this.isConfirmDeletion = true;
                            this.saveOrUpdate();
                        }
                    });
                } else {
                    this.saveOrUpdate();
                }
            });

        } else {
            this.saveOrUpdate();
        }
    }


    deleteExistedFutureRecordDetails() {
        if (this.isConfirmDeletion) {
            let form_data = {
                masterId: this.clauseExtension.id,
                futureDataType: FutureDataType.CLAUSE_EXTENSION.valueOf(),
                fromEffectiveDateFormatted: this.clauseExtension.fromEffectiveDate
            }
            this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
                console.log(response);
                this.isConfirmDeletion = false;
            });
        }
    }
    checkLength(event) {
        // if (this.clauseExtension.id !== undefined) {      
        if (CommonUtils.isNotNil(this.clauseExtension.id)) {      
            if (this.clauseExtension.clauseExtensionType == event.target.value) {
                this.clauseExtension.clauseDescrition = ''
                this.clauseExtension.extensionDescription = ''
            }
        }
        
    }
}
